// src/lib/platforms.js
// Shared AI platform detection — used by EntryCard, MarketplacePage, SkillsPage
// Maps a skill's model string to a platform name, brand colour, and icon SVG.
// All icons are inline SVG so no external requests are needed.

export const PLATFORMS = [
  {
    match: /chatgpt|gpt-?4o?|gpt-?3|gpt|o1|o3/i,
    name: 'ChatGPT',
    color: '#10A37F',
    bg: 'rgba(16,163,127,0.12)',
    icon: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M22.28 9.98a5.83 5.83 0 0 0-.52-4.77 5.9 5.9 0 0 0-6.35-2.83A5.87 5.87 0 0 0 11 .78a5.9 5.9 0 0 0-5.63 4.1 5.87 5.87 0 0 0-3.93 2.85 5.9 5.9 0 0 0 .73 6.9 5.83 5.83 0 0 0 .52 4.77 5.9 5.9 0 0 0 6.35 2.83A5.87 5.87 0 0 0 13 23.22a5.9 5.9 0 0 0 5.64-4.1 5.87 5.87 0 0 0 3.93-2.85 5.9 5.9 0 0 0-.73-6.9zM13 21.5a4.37 4.37 0 0 1-2.81-1.02l.14-.08 4.67-2.7a.77.77 0 0 0 .39-.67v-6.6l1.97 1.14a.07.07 0 0 1 .04.06v5.46A4.4 4.4 0 0 1 13 21.5zm-9.4-4.05a4.38 4.38 0 0 1-.52-2.96l.14.08 4.67 2.7a.77.77 0 0 0 .77 0l5.7-3.3V16a.07.07 0 0 1-.03.06L9.6 18.8a4.4 4.4 0 0 1-6-1.35zM2.87 8.06A4.37 4.37 0 0 1 5.15 6l-.01.16v5.4a.77.77 0 0 0 .39.67l5.7 3.3-1.97 1.14a.07.07 0 0 1-.07 0L4.4 13.9a4.4 4.4 0 0 1-1.53-5.84zm16.21 3.77-5.7-3.3 1.97-1.13a.07.07 0 0 1 .07 0l4.78 2.76a4.39 4.39 0 0 1-.68 7.92v-5.56a.77.77 0 0 0-.39-.67zm1.96-3-.14-.08-4.67-2.7a.77.77 0 0 0-.78 0l-5.7 3.3V8a.07.07 0 0 1 .03-.06l4.78-2.76a4.39 4.39 0 0 1 6.48 4.55zM9.1 13.11l-1.97-1.14a.07.07 0 0 1-.04-.06V6.45a4.39 4.39 0 0 1 7.2-3.37l-.14.08-4.67 2.7a.77.77 0 0 0-.39.67zm1.07-2.3 2.54-1.46 2.54 1.46v2.93L12.7 14.7l-2.54-1.46z"/></svg>`,
  },
  {
    match: /claude|anthropic/i,
    name: 'Claude',
    color: '#D97706',
    bg: 'rgba(217,119,6,0.12)',
    icon: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M4.709 15.955l4.72-2.647.08-.23-.08-.128-4.72 2.647zM9.43 5.993L4.71 8.64l4.72 7.317.079.23V5.762zm5.65 7.962l4.72 2.647-4.72-2.647zm0-7.962v10.425l.08-.23 4.719-7.317zm-5.651 8.52l4.77-8.52H9.43zm0 0"/></svg>`,
  },
  {
    match: /gemini|bard/i,
    name: 'Gemini',
    color: '#4285F4',
    bg: 'rgba(66,133,244,0.12)',
    icon: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 24A14.3 14.3 0 0 0 0 12 14.3 14.3 0 0 0 12 0a14.3 14.3 0 0 0 12 12 14.3 14.3 0 0 0-12 12z"/></svg>`,
  },
  {
    match: /perplexity/i,
    name: 'Perplexity',
    color: '#20B2AA',
    bg: 'rgba(32,178,170,0.12)',
    icon: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L2 7l10 5 10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>`,
  },
  {
    match: /grok/i,
    name: 'Grok',
    color: '#fff',
    bg: 'rgba(255,255,255,0.1)',
    icon: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>`,
  },
  {
    match: /copilot|bing/i,
    name: 'Copilot',
    color: '#0078D4',
    bg: 'rgba(0,120,212,0.12)',
    icon: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.5 0h-13C2.46 0 0 2.46 0 5.5v13C0 21.54 2.46 24 5.5 24h13c3.04 0 5.5-2.46 5.5-5.5v-13C24 2.46 21.54 0 18.5 0zM12 18.75c-3.72 0-6.75-3.03-6.75-6.75S8.28 5.25 12 5.25s6.75 3.03 6.75 6.75-3.03 6.75-6.75 6.75z"/></svg>`,
  },
  {
    match: /higgsfield/i,
    name: 'Higgsfield',
    color: '#F5A623',
    bg: 'rgba(245,166,35,0.12)',
    icon: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"/></svg>`,
  },
  {
    match: /midjourney|mj\b/i,
    name: 'Midjourney',
    color: '#9B59B6',
    bg: 'rgba(155,89,182,0.12)',
    icon: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12.5 2.5L2 19h5l1.5-2.5h7L17 19h5L12.5 2.5zm0 5l2.5 4.5h-5L12.5 7.5z"/></svg>`,
  },
  {
    match: /runway/i,
    name: 'Runway',
    color: '#e24b4a',
    bg: 'rgba(226,75,74,0.12)',
    icon: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M4 4h16v2H4zm2 4h12v2H6zm-2 4h16v2H4zm2 4h12v2H6z"/></svg>`,
  },
  {
    match: /dall-?e|dalle/i,
    name: 'DALL·E',
    color: '#10A37F',
    bg: 'rgba(16,163,127,0.12)',
    icon: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/></svg>`,
  },
  {
    match: /sora/i,
    name: 'Sora',
    color: '#10A37F',
    bg: 'rgba(16,163,127,0.12)',
    icon: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/></svg>`,
  },
  {
    match: /stable.diffusion|stability/i,
    name: 'Stable Diffusion',
    color: '#7C3AED',
    bg: 'rgba(124,58,237,0.12)',
    icon: `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L2 7l10 5 10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>`,
  },
];

export function detectPlatform(model) {
  if (!model) return null;
  return PLATFORMS.find(p => p.match.test(model)) || null;
}

// Render a small platform chip inline — returns style + content info
export function getPlatformChip(model) {
  const p = detectPlatform(model);
  if (!p) return null;
  return {
    name: p.name,
    color: p.color,
    bg: p.bg,
    icon: p.icon,
  };
}
